import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import MessageTextCircle02Icon from "@redotech/redo-icons/message-text-circle-02.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const TextConciergeItems = memo(function TextConciergeItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const location = useLocation();

  const flagLoad = useLoad(
    (signal) =>
      marketingRpcClient.getBooleanFeatureFlag(
        { key: FeatureFlagKey.SHOPPER_AGENT },
        { signal },
      ),
    [marketingRpcClient],
  );

  const isEnabled = flagLoad.value?.enabled ?? false;

  const anyChildSelected = !!matchPath(
    `${routes.textConciergeHref}/*`,
    location.pathname,
  );

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.textConciergeHref }}
      anyChildSelected={anyChildSelected}
      FilledIcon={MessageTextCircle02Icon}
      friendlyName="Text Concierge"
      hidden={!isEnabled}
      id="text-concierge"
      UnfilledIcon={MessageTextCircle02Icon}
    />
  );
});
